<template>
	<div
		class="flex flex-col app-input-container"
		:class="{ 'has-error': validation.errors.length > 0, [containerClass]: containerClass }"
	>
		<div class="relative w-full justify-center">
			<transition name="slide-fade" mode="out-in">
				<app-label v-if="modelValue !== null && modelValue !== undefined && !hideLabel">
					{{ $attrs.placeholder }}
				</app-label>
			</transition>
			<Multiselect
				:id="generateRandomId"
				v-bind="$attrs"
				:model-value="modelValue"
				@close="validation.setTouched && validation.setTouched(true)"
				ref="AppMultiSelectRef"
				@keypress.ctrl="escapeBug"
			>
				<template v-for="(_, slot) of $slots" v-slot:[slot]="scope">
					<slot :name="slot" v-bind="scope" />
				</template>
			</Multiselect>
			<app-icon
				v-if="modelValue && clearable"
				icon="cancel"
				class="absolute text-13 text-warning cursor-pointer"
				style="top: 40%; right: 32px"
				@click="$emit('deselect', null)"
			/>
			<transition name="slide-fade-reverse">
				<span
					class="error-message text-13 text-error"
					v-if="validation.meta.touched || validation.errors.length > 0"
				>
					{{ validation.errorMessage }}
				</span>
			</transition>
		</div>
	</div>
</template>

<script>
	import AppLabel from '../typography/AppLabel';
	import Multiselect from '@vueform/multiselect';
	import AppIcon from '@/components/app/AppIcon';

	export default {
		name: 'AppSelect',
		inheritAttrs: true,
		emits: ['select, deselect'],
		components: {
			AppIcon,
			Multiselect,
			AppLabel,
		},
		computed: {
			generateRandomId() {
				return Math.floor(Math.random() * 100000);
			},
		},
		props: {
			validation: {
				type: Object,
				default: () => ({
					meta: {},
					errors: [],
				}),
			},
			modelValue: {},
			hideLabel: {
				type: Boolean,
				default: false,
			},
			containerClass: {},
			clearable: {
				type: Boolean,
				default: false,
			},
		},
		data: () => ({
			renderComponent: true,
		}),
		methods: {
			escapeBug(e) {
				console.log(e);
			},
		},
	};
</script>
